import Box from "./Box"

const Relative = Box.extend({
  position: "relative",
})

Relative.displayName = "Relative"

export default Relative



// WEBPACK FOOTER //
// ./src/components/Relative.js